/**
 * The first error message the API sent, from the { data, errors, status } envelope, or a
 * fallback. Axios buries it in response.data.
 */
export const apiError = (error, fallback) => {
	const errors = error?.response?.data?.errors

	return (Array.isArray(errors) && errors[0]) || fallback
}
